/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Project_FileInputs */



/**
* | output |
* | --- |
* | "Select Project File" |
*
* @param {Select_Project_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_project_file = /** @type {((inputs?: Select_Project_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Project_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner le fichier de projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektdatei auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona file di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите файл проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar archivo de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择项目文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトファイルを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट फ़ाइल का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o arquivo do projeto")
	return /** @type {LocalizedString} */ ("Select Project File")
});